<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="区总待下单填写"
      width="520px"
      top="12vh"
      append-to-body
      @close="$reset('form')">
    <el-form ref="form" :model="form" :rules="ruleValidate" label-width="110px">
      <el-form-item label="区域" prop="departmentName">
        <div style="display: flex;flex-direction: row;">
          <el-input v-model="form.departmentName" placeholder="请输入" readonly>
            <el-button slot="append" icon="el-icon-search" @click="$refs.selectDepartment.open()">选择区域</el-button>
          </el-input>
          <department-select ref="selectDepartment" @select="selectDepartment"/>
        </div>
      </el-form-item>
      <el-form-item label="待下单周" prop="weekDate">
        <el-date-picker
            v-model="form.weekDate"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择待下单周"
            style="width: 100%"/>
      </el-form-item>
      <el-form-item label="待下单金额(万元)" prop="pendingAmount">
        <el-input-number v-model="form.pendingAmount" :precision="2" :min="0" :controls="false" style="width: 100%"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import DepartmentSelect from "@/views/information/Department/DepartmentSelect";

  export default {
    name: "PendingOrderEdit",
    components: {DepartmentSelect},
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        form: {
          pkid: null,
          departmentId: null,
          departmentName: "",
          weekDate: "",
          pendingAmount: 0,
        },
        ruleValidate: {
          departmentName: {required: true, message: "请选择区域", trigger: "blur"},
          weekDate: {required: true, message: "请选择待下单周", trigger: "change"},
        },
      };
    },
    methods: {
      open(row) {
        if (row && row.pkid) {
          this.form.pkid = row.pkid;
          this.form.departmentId = row.departmentId;
          this.form.departmentName = row.departmentName;
          this.form.weekDate = row.weekDate;
          this.form.pendingAmount = row.pendingAmount;
        } else {
          this.form.pkid = null;
          this.form.departmentId = null;
          this.form.departmentName = "";
          this.form.weekDate = "";
          this.form.pendingAmount = 0;
        }
        this.dialogVisible = true;
      },
      selectDepartment(row) {
        this.form.departmentId = row.departmentID;
        this.form.departmentName = row.departmentName;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (!valid) {
            return;
          }
          this.submitLoading = true;
          this.$http
            .post("basic", "sd/salesRevenueReport/savePendingOrder", this.form)
            .then(resp => {
              this.submitLoading = false;
              if (resp && resp.success === false) {
                return this.$message.error(resp.message || "保存失败");
              }
              this.dialogVisible = false;
              this.$message.success("保存成功");
              this.$emit("save-success");
            })
            .catch(() => {
              this.submitLoading = false;
            });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
